
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";
import { ChevronLeft, Plug } from "lucide-react";
import Navbar from "@/components/Navbar";
import { PluginDownloadSection } from "@/components/wordpress/PluginDownloadSection";
import { ConfigurePluginSection } from "@/components/wordpress/ConfigurePluginSection";
import { ConnectWordPressSection } from "@/components/wordpress/ConnectWordPressSection";
import { PluginFeatures } from "@/components/wordpress/PluginFeatures";
import { PluginDocumentation } from "@/components/wordpress/PluginDocumentation";
import { PluginTestingLink } from "@/components/wordpress/PluginTestingLink";

export default function WordPressPlugin() {
  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar isLoggedIn={true} />
      
      <div className="container mx-auto py-10 px-4 max-w-4xl">
        <div className="mb-8">
          <Button variant="outline" asChild className="mb-4">
            <Link to="/dashboard">
              <ChevronLeft className="mr-2 h-4 w-4" />
              Back to Dashboard
            </Link>
          </Button>
          
          <h1 className="text-3xl font-bold mb-2">WordPress Plugin</h1>
          <p className="text-gray-500">
            Connect your WordPress sites using our dedicated plugin for seamless backups.
          </p>
        </div>
        
        <div className="grid gap-6">
          <Card>
            <CardContent className="p-6">
              <div className="flex items-center mb-4">
                <Plug className="mr-2 h-5 w-5" />
                <h2 className="text-xl font-bold">WordPress Backup Connector Plugin</h2>
              </div>
              <p className="text-gray-500 mb-6">
                Install our plugin on your WordPress website to enable secure backups and restore functionality.
              </p>
              
              <div className="space-y-6">
                <PluginDownloadSection />
                
                <Separator />
                
                <ConfigurePluginSection />
                
                <Separator />
                
                <ConnectWordPressSection />
                
                <PluginTestingLink />
              </div>
            </CardContent>
          </Card>
          
          <PluginFeatures />
          
          <PluginDocumentation />
        </div>
      </div>
    </div>
  );
}
